import type { Node } from '@menuvera/engine';

export function resolveOverlayId(root: Node): string | null {
  if (root.kind === 'overlay') return root.id;
  if (root.kind === 'stack' || root.kind === 'grid' || root.kind === 'group' || root.kind === 'frame') {
    const overlay = root.children.find((child) => child.kind === 'overlay');
    return overlay?.id ?? null;
  }
  return null;
}

export function findOverlayPlacement(
  root: Node,
  nodeId: string,
): {
  overlayId: string;
  childIndex: number;
  child: import('@menuvera/engine').OverlayChild;
} | null {
  if (root.kind === 'overlay') {
    const childIndex = root.children.findIndex((child) => child.node.id === nodeId);
    if (childIndex >= 0) {
      return { overlayId: root.id, childIndex, child: root.children[childIndex]! };
    }
  }
  for (const child of walkChildren(root)) {
    const found = findOverlayPlacement(child, nodeId);
    if (found) return found;
  }
  return null;
}

export function collectOverlayNodeRects(
  root: Node,
): Array<{ id: string; x: number; y: number; width: number; height: number }> {
  const out: Array<{ id: string; x: number; y: number; width: number; height: number }> = [];
  collect(root, out);
  return out;
}

function collect(
  node: Node,
  out: Array<{ id: string; x: number; y: number; width: number; height: number }>,
): void {
  if (node.kind === 'overlay') {
    for (const child of node.children) {
      out.push({
        id: child.node.id,
        x: child.x,
        y: child.y,
        width: child.width,
        height: child.height,
      });
      collect(child.node, out);
    }
    return;
  }
  for (const child of walkChildren(node)) collect(child, out);
}

function walkChildren(node: Node): Node[] {
  switch (node.kind) {
    case 'stack':
    case 'grid':
    case 'group':
    case 'frame':
      return node.children;
    case 'overlay':
      return node.children.map((child) => child.node);
    case 'repeater':
      return [node.itemTemplate, ...(node.empty ? [node.empty] : [])];
    case 'slot':
      return node.defaultChild ? [node.defaultChild] : [];
    default:
      return [];
  }
}
